
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'


@Component({
  name: 'guitarMap',
  components: { }
})
export default class extends Vue {
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  city: string = ''
  guitarMap: any = null
  guitarPoint: any = null
  innerHeight: string = ''
  mapCenter: any = {lng: 116.331398, lat: 39.897445}
  lng: number = 116.331398
  lat: number = 39.897445
  customerList: any = []
  campusList: any = []
  active: boolean = false


  mounted() {
    this.getHeight()
    this.getCustomerMap()
  }
  draw (region, map, el) {
    const pixel = map.pointToOverlayPixel( {lng: region.split(',')[0],lat: region.split(',')[1]})
    el.style.left = pixel.x - 70 + 'px'
    el.style.top = pixel.y - 40 + 'px'
  }
  getHeight() {
    this.innerHeight = (window.innerHeight - 100) + 'px'
  }
  mouseoverLine(val, item, type) {
    item.active = true
    let num: any = 0
    if(type === 'customer') {  // 客户
      num = item.address.length
      if( 14 * num < 140) {
        item.width = 140
      } else {
        item.width = 14 * num
      }
    } else {  // 校区
       num = item.name.length
       if( 16 * num < 140) {
        item.width = 140
      } else {
        item.width = 16 * num
      }
    }
  }
  mouseleaveLine(val, item) {
    item.active = false
    item.width = 140
  }

  copyMapList(arr) {
    for(var i = 0; i < arr.length; i++) {
       Vue.set(arr[i], 'active', false)
       Vue.set(arr[i], 'width', '140')
    }
  }

  async getCustomerMap() {
    const res: any = await CourseModule.customerMap()
    if(res.code === 200) {
        this.customerList = res.data.customer
        this.campusList = res.data.campus
        this.lng = Number(this.campusList[0].coordinate.split(',')[0])
        this.lat = Number(this.campusList[0].coordinate.split(',')[1])
        this.copyMapList(this.customerList)
        this.copyMapList(this.campusList)
    }
  }
}
